<template>
  <div class="media-list" v-loading="redirectLoading">
    <subfield :isShowNav="true">
      <template slot="list">
        <trees type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
        <trees type="CATALOG" @getAssets="getAssets" :list="configList"></trees>
      </template>
      <template slot="content">
        <enfold-uc>
          <template slot="up">
            <div class="c-u-left">
              <img src="@/assets/images/public/public_upload.png" @click="$router.push({name: 'MediaUp',params: {id:$route.params.id, event:$route.params.event ,iscopy:$route.params.iscopy}})" class="icon" alt />
            </div>
            <div class="c-u-right">
              <el-input v-model="keyword" :placeholder="$t('public.search')" @focus="keyword = undefined">
                <i slot="suffix" class="el-icon-search" @click="keyword && search(keyword)"></i>
              </el-input>
              <img src="@/assets/images/public/public_filter.png" @click="filter" class="icon" alt />
            </div>
          </template>
          <template slot="center">
            <div class="c-left" v-loading="loading">
              <ul class="material-list" ref="mList" v-infinite-scroll="loadMedia" :infinite-scroll-delay="500">
                <li v-for="media in mediaList" :key="media.id" class="material-item">
                  <multimedia-item :cardData="media" :cardSelect="cardSelect" @mediaSelect="mediaSelect" @selectChange="handleCurrentChange"></multimedia-item>
                </li>
                <!-- 此行代码用于格式化媒体显示卡片对齐 -->
                <i v-for="(item, index) in mediaList" :key="index+'$'"></i>
              </ul>
              <div class="c-loading" v-if="stopLoad">
                <span v-if="loading">-Loading...-</span>
                <span v-else @click="loadMedia">-{{$t('csca1')}}-</span>
              </div>
              <div class="c-loading" v-else>
                <span v-if="flagPage>1">-{{$t('csca2')}}-</span>
                <span v-else>-{{$t('csca3')}}-</span>
              </div>
            </div>
            <div class="c-right">
              <div class="c-r-top">
                <div class="t-sel">
                  <div class="t-sel-label">{{$t('csca4')}}:</div>
                  <el-select v-model="equipmentValue" :placeholder="$t('csca5')" size="mini">
                    <el-option :label="$t('csca6')" value="0" @click.native="msgOpenDialog"></el-option>
                    <el-option v-for="item in equipment" :key="item.id" :label="item.name" :value="item.id" :disabled="true">
                      <span style="float: left">{{ item.name }}</span>
                      <!-- <span @click="delDevice(item.id)" style="float: right; color: #ff7878 ; font-size: 16px">
                        <i class="el-icon-delete"></i>
                      </span>-->
                    </el-option>
                  </el-select>
                </div>
                <div class="t-sel">
                  <div class="t-sel-label">播放模式:</div>
                  <el-select v-model="playModeValue" :placeholder="$t('csca7')" size="mini">
                    <el-option v-for="item in playMode" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
                <div class="t-sel add-schedule">
                  <div class="t-sel-label" @click="addSchedule">
                    <img class="icon" src="@/assets/images/public/public_add.png" alt />
                    <span style="padding-left: 10px;">{{$t('csca8')}}</span>
                  </div>
                </div>
              </div>
              <div class="c-r-bottom" ref="scheduleList">
                <ul class="schedule">
                  <schedule-item v-for="(item,index) in ScheduleData" :key="item.id" :index="index" :scheduleItem="item" :selectItem="selectIndex === item.id" @editSchedule="editSchedule" @deleteSchedule="deleteSchedule"></schedule-item>
                </ul>
              </div>
              <div class="c-r-submit">
                <div>
                  <el-button size="mini" round @click="$router.go(-1)">{{$t('csca9')}}</el-button>
                  <el-button size="mini" type="success" round @click="save(3)">{{$t('csca10')}}</el-button>
                  <el-button size="mini" type="primary" round @click="submit(0)">{{$t('csca11')}}</el-button>
                </div>
              </div>
            </div>
          </template>
        </enfold-uc>
      </template>
    </subfield>
    <msg-dialog :dialogVisible="msgDialogVisible" @closeDialog="msgCloseDialog" top="8vh" dWidth="800px" :title="$t('csca12')" class="equipment-msg">
      <div class="equipment">
        <div class="equipment-left">
          <trees type="GROUP" @getAssets="getEquipmentAssets" :list="groupList"></trees>
        </div>
        <div class="equipment-right">
          <div class="e-r-top">
            <div></div>
            <div class="c-u-right">
              <el-input v-model="equipmentKeyword" :placeholder="$t('csca13')">
                <i slot="suffix" class="el-icon-search" @click="equipmentSearch(keyword)"></i>
              </el-input>
              <!-- <img src="@/assets/images/public/public_filter.png" class="icon" alt /> -->
            </div>
          </div>
          <div class="e-r-center">
            <el-table v-loading="equipmentLoading" ref="multipleTable" :data="deviceList" style="width: 100%" @select-all="handleSelectionAll" @select="handleSelectionRow">
              <el-table-column type="selection" width="60"></el-table-column>
              <el-table-column prop="name" :label="$t('csca14')"></el-table-column>
              <el-table-column prop="group_name" :label="$t('csca15')"></el-table-column>
              <el-table-column prop="type_remark" :label="$t('csca16')"></el-table-column>
              <el-table-column :label="$t('csca17')">
                <div slot-scope="scope" v-if="scope.row.run_state" v-html="runState(scope.row.run_state,scope.row.group_run_status)"></div>
                <div v-else>
                  <span style="color: #ea1a1a;">{{$t('csca18')}}</span>
                </div>
              </el-table-column>
              <el-table-column prop="size_remark" :label="$t('csca19')"></el-table-column>
            </el-table>
          </div>
          <div class="e-r-bottom">
            <pagination :current="equipmentCurrent" :limit="limit" @currentChange="currentChange"></pagination>
          </div>
        </div>
      </div>
    </msg-dialog>
    <msg-dialog :dialogVisible="msgFileDialogVisible" @closeDialog="closeDialog" :title="$t('csca20')">
      <div v-for="(file,key) in fileType" :key="key" class="filter">
        <div class="title">{{file.typeName}}</div>
        <div class="check-all">
          <el-checkbox :indeterminate="file.isIndeterminate" v-model="file.checkAll" @change="handleCheckAllChange(file,file.checkAll)">全选</el-checkbox>
        </div>
        <div class="check-item">
          <el-checkbox-group v-model="file.list" @change="handleCheckedChange(file,file.list)">
            <el-checkbox v-for="(item,index) in file.checkedList" :label="item" :key="index"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </msg-dialog>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import EnfoldUc from '@/components/basics/EnfoldUC'
import MsgDialog from '@/components/basics/MsgDialog'
import pagination from '@/components/basics/Pagination'
import trees from '@/components/basics/Trees'
import ScheduleItem from './ScheduleItem'
import MultimediaItem from './MultimediaItem'
// eslint-disable-next-line no-unused-vars
import { mediaData, signalSourceData } from '@/assets/scripts/filesData'
import { superDeepClone } from "@/assets/scripts/clone"
import { getBase64Image } from "@/assets/scripts/publicFunction"
import { runStateInfo } from "@/assets/scripts/runState"
import { mPagination } from "@/components/basics/mixins";
import { reDateFormatting, reTimeFormatting } from "@/assets/scripts/dateFormatting";

export default {
  name: 'playlist',
  mixins: [mPagination],
  data() {
    return {
      groupList: [],
      configList: [],
      equipmentCurrent: 110,
      selectIndex: -1,
      flagPage: 0,
      equipmentKeyword: "",
      equipmentGroupIds: sessionStorage.getItem('group_ids'),
      loading: true,
      equipmentLoading: true,
      redirectLoading: false, // 节目排程添加完成时加载动画
      stopLoad: true,
      ScheduleData: [],
      playModeValue: "0",
      playMode: [{
        value: '0',
        label: this.$t('csca21')
      }],
      mediaList: [],
      cardSelect: "",
      equipmentValue: "",
      equipment: [], // 当前选中的关联设备
      msgDialogVisible: false,
      msgFileDialogVisible: false,
      deviceList: [],
      multipleSelection: [],
      currentMedia: null,
      playName: "",
      playIds: "",
      isAppend: 1,
      fabuState: 0,
      fileType: null,
      type: undefined,
      refW: undefined,
      refSize: undefined,
      keyword: undefined
    }
  },
  async created() {
    // 当页面刷新时读取不到状态就返回上个页面
    !this.$route.params.event && this.$router.go(-1);
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    this.$http.post("/admin/material/configList", { flag: 1 }, data => {
      this.configList = data.dir;
    });
    this.$route.params.id && await this.$http.post("/admin/fabu/edit", {
      id: this.$route.params.id,
      iscopy: this.$route.params.iscopy,
      limit: this.limit
    }, data => {
      this.editInit(data);
    });
    await this.getMaterialList();
    this.scrollTop();
    // console.log(this.mediaList.find(item => item.id === this.cardSelect));
    this.currentMedia = this.cardSelect !== "" ? this.mediaList.find(item => item.id === this.cardSelect) : this.cardSelect;

    // 页面初始化是自动添加一个排程
    !this.$route.params.id && this.ScheduleData.push(this.newSchedule());
    // 筛选初始化
    this.fileType = this.fileTypeData();
  },
  methods: {
    // 初始化修改排程的数据
    async editInit(data) {
      // console.log(data);
      // 初始化历史选中素材
      this.cardSelect = data.material_ids[0];
      // 初始化历史选中设备
      this.equipment = [...data.device_ids];
      // 初始化历史排程设置
      // this.ScheduleData = [...data.play_schedule];
      this.ScheduleData = superDeepClone(data.play_schedule);
      // 初始化上滚刷新 
      this.$nextTick(() => {
        this.$refs.mList.addEventListener('scroll', () => {
          if (this.$refs.mList.scrollTop === 0 && this.flagPage > 1) {
            this.flagPage -= 1;
            this.getMaterialListUnshift();
            console.log(this.$refs.mList.scrollTop);

          }
        }, true);
      });
      this.page = data.page;
      this.flagPage = data.page - 1;
      this.flagPage > 1 && await this.getMaterialListUnshift();

    },
    // async getMaterialListUnshift(media = { group_id: this.groupId, dir_id: this.dirId, limit: this.limit, type: "", page: this.page - 1 }) {
    //   await this.$http.post("/admin/material/list", media, data => {
    //     this.mediaList = data.list ? data.list.concat(this.mediaList) : [];
    //     this.current = parseInt(data.count);
    //     this.loading = false;
    //   });
    // },
    getMaterialListUnshift(media = {
      group_ids: this.groupIds,
      dir_id: this.dirId,
      limit: this.limit,
      page: this.flagPage,
      key_word: this.keyword,
      type: this.type,
      refW: this.refW,
      refSize: this.refSize
    }) {
      this.loading = true;
      this.$http.post("/admin/material/list", media, data => {
        this.mediaList = data.list ? data.list.concat(this.mediaList) : [];
        this.current = parseInt(data.count);
        this.loading = false;
        // 当页面资源媒体加载完成后默认将滚动条向下滚动10px,解决修改节目时上滚刷新无效
        this.scrollTop();
      });
    },
    scrollTop() {
      // 当页面资源媒体加载完成后默认将滚动条向下滚动10px,解决修改节目时上滚刷新无效
      this.$nextTick(() => {
        this.$refs.mList.scrollTop = 10;
      })
    },
    runState(rt, gt) {
      let rti = runStateInfo(rt, gt);
      return `<span style="color: ${rti.stateColor};">${rti.stateName}</span>`;
    },
    // 素材列表请求http
    async getMaterialList(media = {
      group_ids: this.groupIds,
      dir_id: this.dirId,
      limit: this.limit,
      page: this.page,
      key_word: this.keyword,
      type: this.type,
      refW: this.refW,
      refSize: this.refSize
    }) {
      this.loading = true;
      await this.$http.post("/admin/material/list", media, data => {
        this.mediaList = data.list ? this.mediaList.concat(data.list) : [];
        this.current = parseInt(data.count);
        this.loading = false;
        // 当页面资源媒体加载完成后默认将滚动条向下滚动10px,解决修改节目时上滚刷新无效
      });
    },
    // 设备列表请求http
    async getDeviceList(device = { group_ids: this.equipmentGroupIds, limit: 12, type_id: 2, page: 1 }) {
      this.equipmentLoading = true;
      await this.$http.post("/admin/device/list", device, data => {
        this.deviceList = data.list ? data.list : [];
        this.equipmentCurrent = parseInt(data.count);
        this.equipmentLoading = false;
      });
    },
    // 下拉加载多媒体资源
    loadMedia() {
      // this.mediaList.length < this.current ?
      if (this.page * this.limit < this.current) {
        this.page += 1;
        this.getMaterialList();
      } else {
        this.stopLoad = false;
      }
    },
    // 组织结构与媒体目录切换重新加载资源
    getAssets(ids) {
      console.log(ids);
      this.mediaList = [];
      this.page = 1;
      this.stopLoad = true;
      if (ids.type === "GROUP") {
        this.groupId = ids.id
      }
      if (ids.type === "CATALOG") {
        this.dirId = ids.id
      }
      this.getMaterialList();
    },
    // 组织结构切换重新加载关联设备
    getEquipmentAssets(ids) {
      console.log(ids);
      if (ids.type === "GROUP") {
        this.equipmentGroupIds = ids.ids
      }
      this.getDeviceList();
      // 当组织结构发生切换事件时所选择的终端设备全部取消勾选；
      this.multipleSelection = [];
      this.equipment = [];
    },
    // 搜索资源
    search(keyword) {
      this.keyword = keyword;
      this.page = 1;
      this.stopLoad = true;
      this.mediaList = [];
      this.getMaterialList();
      // this.keyword = undefined;
    },
    closeDialog(isConfirm) {
      if (isConfirm) {
        // 数据处理函数
        let filter = (list, typeList, qr = true) => {
          let type = [];
          list.forEach((item) => {
            qr ? type = type.concat(typeList[item]) : type.push(typeList[item]);
          });
          return qr ? type.sort((a, b) => a - b) : type;
        }
        // 文件类型
        let type = [];
        let fileType = { '视频': [1], '图片': [2], '音乐': [6], '文本': [10] }
        // this.fileType.fileType.list.forEach((item) => {
        //   type.push(fileType[item]);
        // });
        type = filter(this.fileType.fileType.list, fileType);
        // 文件尺寸
        let ref_wh = [];
        let fileResolution = { '4K': [3264, 999999999], '2K': [2560, 3263], '1080P': [1920, 2559], '720P': [0, 1919] };
        // this.fileType.fileResolution.list.forEach((item) => {
        //   ref_wh = ref_wh.concat(fileResolution[item])
        // });
        // ref_wh = ref_wh.sort((a, b) => a - b);
        ref_wh = filter(this.fileType.fileResolution.list, fileResolution, false);
        //文件大小
        let ref_size = [];
        let fileSize = { '0M~10M': [0, 10485759], '10M~100M': [10485760, 104857599], '>100M': [104857600, 999999999] }
        // this.fileType.fileSize.list.forEach((item) => {
        //   ref_size = ref_size.concat(fileSize[item])
        // });
        // ref_size = ref_size.sort((a, b) => a - b);
        ref_size = filter(this.fileType.fileSize.list, fileSize, false);

        // 请求格式化
        this.type = type.length > 0 ? type.join(',') : undefined;
        this.refW = ref_wh.length > 0 ? encodeURIComponent(JSON.stringify(ref_wh)) : undefined;
        this.refSize = ref_size.length > 0 ? encodeURIComponent(JSON.stringify(ref_size)) : undefined;
        // this.refW = ref_wh.length > 0 ? JSON.stringify([(ref_wh[0]), (ref_wh[ref_wh.length - 1] === 999999999 ? null : ref_wh[ref_wh.length - 1])]) : undefined;
        // this.refSize = ref_size.length > 0 ? JSON.stringify([(ref_size[0]), (ref_size[ref_size.length - 1] === 999999999 ? null : ref_size[ref_size.length - 1])]) : undefined;
        this.page = 1;
        this.stopLoad = true;
        this.mediaList = [];
        // console.log(this.type);
        // console.log(this.refW);
        // console.log(this.refSize);
        this.getMaterialList();
      }
      this.msgFileDialogVisible = false;
    },
    filter() {
      this.msgFileDialogVisible = true;
    },
    fileTypeData() {
      return {
        fileType: {
          typeName: "文件类型",
          checkAll: false,
          checkedList: ['视频', '图片', '音乐', '文本'],
          list: [],
          isIndeterminate: false
        },
        fileResolution: {
          typeName: "文件尺寸",
          checkAll: false,
          checkedList: ['4K', '2K', '1080P', '720P'],
          list: [],
          isIndeterminate: false
        },
        fileSize: {
          typeName: "文件大小",
          checkAll: false,
          checkedList: ['0M~10M', '10M~100M', '>100M'],
          list: [],
          isIndeterminate: false
        }
      }
    },
    handleCheckAllChange(file, val) {
      file.list = val ? file.checkedList : [];
      file.isIndeterminate = false;
    },
    handleCheckedChange(file, list) {
      console.log(file, list);
      let checkedCount = list.length;
      file.checkAll = checkedCount === file.checkedList.length;
      file.isIndeterminate = checkedCount > 0 && checkedCount < file.checkedList.length;
    },
    // 搜索关联设备
    equipmentSearch(keyword) {
      console.log(keyword);
    },
    // 添加排程
    addSchedule() {
      this.ScheduleData.push(this.newSchedule());
      this.$nextTick(() => {
        this.$refs.scheduleList.scrollTop = this.$refs.scheduleList.scrollHeight;
      })
    },
    // 当前选中媒体回调函数
    mediaSelect(sle) {
      this.cardSelect = sle;
    },
    // 删除排程
    deleteSchedule(index) {
      this.ScheduleData.splice(index, 1);
    },
    // 修改排程
    editSchedule(data, index) {
      this.ScheduleData[index] = data;
      // console.log(this.ScheduleData);
    },
    // 创建排程时初始化的数据
    newSchedule() {
      return {
        action: 1,
        id: (new Date()).valueOf(),
        name: "name",
        startTime: "", // 00:00:00
        endTime: "", // 00:00:00
        isDateLimit: false,
        dateStart: "", // 0000/00/00
        dateEnd: "", // 0000/00/00
        isWeekLimit: false,
        validWeek: 0,
        playCount: 1
      };
    },
    // 当前选中多媒体
    handleCurrentChange(val) {
      this.currentMedia = val;
      console.log(this.currentMedia);
    },
    // 选择发布终端分页
    async currentChange(val) {
      await this.getDeviceList({ group_ids: this.equipmentGroupIds, limit: 12, type_id: 2, page: val });
      this.changePageSelectionAll();
    },
    // 选择发布终端添加到下拉选项
    msgCloseDialog(confirm = false) {
      if (confirm) {
        // this.multipleSelection.forEach(row => {
        //   let index = this.equipment.findIndex((ele) => { return ele.id === row.id; });
        //   index === -1 ? this.equipment.push(row) : 0;
        // });
        this.equipment = [...this.multipleSelection];
      }
      console.log(this.equipment);
      this.msgDialogVisible = false;
    },
    // 打开关联设备弹窗初始化已选关联设备
    async msgOpenDialog() {
      this.msgDialogVisible = true;
      await this.getDeviceList();
      this.equipment.forEach((device, index) => {
        let findDevice = this.deviceList.find(deviceItem => deviceItem.id === device.id);
        if (findDevice !== -1) {
          this.equipment[index] = superDeepClone(findDevice);
        }
      });
      this.multipleSelection = [...this.equipment];
      console.log(this.multipleSelection);
      this.changePageSelectionAll();
    },
    // 全选设备添加删除元素
    handleSelectionAll(val) {
      if (val.length > 0) {
        this.deviceList.forEach(row => {
          let index = this.multipleSelection.findIndex((ele) => { return ele.id === row.id; });
          index === -1 ? this.multipleSelection.push(row) : 0;
        });
      } else {
        this.deviceList.forEach(row => {
          let index = this.multipleSelection.findIndex((ele) => { return ele.id === row.id; });
          index !== -1 ? this.multipleSelection.splice(index, 1) : 0;
        });
      }
    },
    // 单选设备添加删除元素
    handleSelectionRow(selection, row) {
      let isSelect = selection.findIndex((ele) => { return ele.id === row.id; });
      if (isSelect !== -1) {
        this.multipleSelection.push(row)
      } else {
        let index = this.multipleSelection.findIndex((ele) => { return ele.id === row.id; });
        this.multipleSelection.splice(index, 1);
      }
    },
    // 页面切换选中新页面历史已选关联设备
    changePageSelectionAll() {
      this.$nextTick(() => {
        this.multipleSelection.forEach(row => {
          let index = this.deviceList.findIndex((ele) => { return ele.id === row.id; });
          index !== -1 ? this.$refs.multipleTable.toggleRowSelection(this.deviceList[index]) : 0;
        });
      });
    },
    // 删除已选择终端
    delDevice(id) {
      console.log(id);
    },
    // 提交所有设置到服务器
    async submit(val) {
      // val:0提交val:3保存
      this.fabuState = val;
      // 检测排程设置是否合法
      if (this.scheduleDetection() !== -1) {
        return 0;
      }
      // 检测部分设置是否为空
      if (this.equipment.length === 0) {
        this.$msg({ showClose: true, message: this.$t('csca29'), type: 'warning' });
        return 0;
      }
      if (this.currentMedia === null) {
        this.$msg({ showClose: true, message: this.$t('csca30'), type: 'warning' });
        return 0;
      }
      if (this.ScheduleData.length === 0) {
        this.$msg({ showClose: true, message: this.$t('csca31'), type: 'warning' });
        return 0;
      }

      this.redirectLoading = true; // 当点击提交后页面加载动画显示
      await this.addProgram(this.currentMedia);
      // console.log(this.playIds);
      await this.addIssue();
      this.redirectLoading = false; // 当点击提交后页面加载动画显示
    },
    // 检测排程时间格式设置是否正确
    scheduleDetection() {
      // console.log(this.ScheduleData);
      let index = this.ScheduleData.findIndex((item) => {
        if (item.isDateLimit) {
          // 当有有时间限制的时候走该条件
          return reTimeFormatting(item.endTime) < reTimeFormatting(item.startTime) || (reDateFormatting(item.dateEnd) < reDateFormatting(item.dateStart)) || (new Date().getTime() > new Date(Date.parse(`${item.dateEnd} ${item.endTime}`)).getTime());
        } else {
          // 当无时间限制的时候走该条件
          return reTimeFormatting(item.endTime) < reTimeFormatting(item.startTime);
        }
      });
      if (index !== -1) {
        let sItem = this.ScheduleData[index];
        this.$nextTick(() => {
          this.$refs.scheduleList.scrollTop = index * (254 + 12);
          this.selectIndex = sItem.id;
        });
        if ((new Date().getTime() > new Date(Date.parse(`${sItem.dateEnd} ${sItem.endTime}`)).getTime()) && sItem.isDateLimit) {
          this.$msg({ showClose: true, message: `第${index + 1}条排程设置结束时间为历史时间,不可播放!`, type: 'warning' });
        } else {
          this.$msg({ showClose: true, message: `第${index + 1}条排程设置开始时间大于结束时间!`, type: 'warning' });
        }
      }
      return index;
    },
    // 添加多个判断条件
    // scheduleDetection() {
    //   console.log(this.ScheduleData);
    //   let index = this.ScheduleData.findIndex((item) => {
    //     return this.formatting_s(item.endTime) < this.formatting_s(item.startTime);
    //   });
    //   if (index !== -1) {
    //     let sItem = this.ScheduleData[index];
    //     this.$nextTick(() => {
    //       this.$refs.scheduleList.scrollTop = index * (254 + 12);
    //       this.selectIndex = sItem.id;
    //     });
    //     this.$msg({ showClose: true, message: `第${index + 1}条排程设置开始时间大于结束时间!`, type: 'warning' });
    //   }
    //   return index;
    // },
    // formatting_s(time) {
    //   let time_s = time.split(':');
    //   return parseInt(time_s[0]) * 60 * 60 + parseInt(time_s[1]) * 60 + parseInt(time_s[2]);
    // },
    // 保存所有设置到服务器
    save(val) {
      // val:0提交val:3保存
      this.fabuState = val;
      this.submit(val);
    },
    async addProgram(currentMedia) {
      let modulesData = null;
      let media = mediaData(currentMedia);
      let signalSource = signalSourceData();
      console.log('currentMedia----->', currentMedia);
      if (currentMedia.type !== "5") {
        media.field_item.ext_val.pimg = currentMedia.ref_url;
        media.field_item.ext_val.name = currentMedia.ref_name;
        media.field_item.ext_val.size = currentMedia.ref_size;
        media.field_item.ext_val.wh = currentMedia.ref_wh;
        media.field_item.id = currentMedia.ref_id;
        media.field_item.val = currentMedia.ref_url;
        modulesData = media;
      } else {
        signalSource.field_item.ext_val.url = currentMedia.ref_url;
        signalSource.field_item.val = currentMedia.ref_url;
        modulesData = signalSource;
      }
      let formData = {};
      formData.group_id = this.$cookies.get("group_id");
      formData.size_id = this.currentMedia.ref_wh !== "" ? this.currentMedia.ref_wh : "1024x768";
      this.playName = "play_" + new Date().getTime();
      formData.name = this.playName;
      // let image = new Image();
      // image.setAttribute('crossOrigin', 'anonymous');
      // image.src = currentMedia.ref_thumb_url;
      formData.pimg = await this.newImage(currentMedia.ref_thumb_url, formData);
      // formData.pimg = currentMedia.ref_thumb_url;
      formData.object_json = encodeURIComponent(JSON.stringify([modulesData]));
      await this.$http.post("/admin/play/addNewKommander", formData, data => {
        this.playIds = data.play_id;
      });
    },
    async addIssue() {
      let postParams = {
        group_id: this.$cookies.get("group_id"),
        play_ids: this.playIds,
        device_ids: this.equipment.map(res => { return res.id; }).join(','),
        play_mode: 2,  // 0-单次1-定时2-循环3-自定义次数
        fabu_strategy: 1, // 0-无1-发布排程2-发布插播
        fabu_type: '1',
        releaseType: 0,
        isAppend: this.isAppend,
        fabu_state: this.fabuState,
        device_typeId: 2,
        playSchedule: superDeepClone(this.ScheduleData)
      };
      // 当为编辑节目时需要添加iscopy与fabu_id
      if (this.$route.params.id && this.$route.params.iscopy) {
        postParams.fabu_id = this.$route.params.id;
        postParams.iscopy = this.$route.params.iscopy;
      }
      postParams.playSchedule.forEach((item) => {
        item.id = this.playIds;
        item.name = this.playName;
      });
      postParams.playSchedule = encodeURIComponent(JSON.stringify(postParams.playSchedule));
      await this.$http.post("/admin/fabu/add", postParams, data => {
        this.playIds = data.play_id;
        this.$msg({ showClose: true, message: this.$t('csca34'), type: 'success' });
        // 节目排程添加成功3秒后跳转到播放日程列表
        this.$router.go(-1);
      });
    },
    newImage(url) {
      return new Promise(function (resolve, reject) {
        const image = new Image();
        image.setAttribute('crossOrigin', 'anonymous');
        image.src = url;
        image.onload = function () {
          resolve(image);
        };
        image.onerror = function () {
          reject(new Error('Could not load image at ' + url));
        };
        image.src = url;
      }).then(
        res => {
          return getBase64Image(res);
        },
        err => {
          console.log('err----->', err);
          return false;
        },
      );
    }
  },
  components: {
    subfield,
    trees,
    EnfoldUc,
    ScheduleItem,
    MultimediaItem,
    MsgDialog,
    pagination
  }
}
</script>

<style lang="scss" scoped>
.media-list {
  width: 100%;
  height: 100%;
  .c-u-right {
    display: flex;
    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
    }
    /deep/ .el-input__suffix {
      line-height: 30px;
      color: var(--theme-color-customized-1);
      font-size: 16px;
      right: 10px;
    }
    .icon {
      margin-right: 0px;
      margin-left: 25px;
    }
  }
  .icon {
    width: 30px;
    height: 30px;
    // margin-right: 25px;
  }
  /deep/ .center {
    display: flex;
    justify-content: space-between;
    padding-top: 6px;
    padding-bottom: 6px;
    .c-left {
      width: calc(100% - 326px);
      border-right: 1px solid #dcdfe6;
      .material-list {
        overflow-y: scroll;
        height: calc(100% - 30px);
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        align-content: flex-start;
        .material-item {
          max-width: 33%;
          .card {
            max-width: 99%;
          }
        }
        // min-height: 578px;
        // 上线适配
        // min-height: 558px;
      }
      .material-list > i {
        width: 148px;
        max-width: 33%;
      }
      .c-loading {
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #606266;
      }
    }
    .c-right {
      width: 320px;
      .c-r-top {
        height: 160px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-bottom: 10px;
        .t-sel {
          display: flex;
          align-items: center;
          height: 44px;
          color: #617883;
          .t-sel-label {
            display: flex;
            align-items: center;
            padding: 12px;
          }
          /deep/ .el-input__inner {
            height: 30px;
            line-height: 30px;
            border-radius: 15px;
          }
        }
        .add-schedule {
          font-size: 18px;
          color: #35cafa;
        }
      }
      .c-r-bottom {
        height: calc(100% - 170px - 40px);
        // max-height: 440px;
        padding: 4px 0px 0px 4px;
        overflow-y: scroll;
        .schedule {
          display: flex;
          flex-direction: column;
        }
      }
      .c-r-submit {
        height: 40px;
        display: flex;
        align-items: center;
        div {
          width: 100%;
          height: 30px;
          display: flex;
          justify-content: space-around;
        }
      }
    }
  }
  .equipment-msg {
    /deep/ .md-content {
      height: calc(100vh - 256px);
    }
  }
  .equipment {
    display: flex;
    height: calc(100vh - 256px);
    .equipment-left {
      flex: 0 0 190px;
      height: 100%;
      border-radius: 0 8px 8px 0;
      background-color: #edfbff;
      display: flex;
      flex-direction: column;
      // .trees:nth-last-child(1):first-child {
      // }
      .trees:nth-last-child(2):first-child {
        height: calc(50% - 6px);
      }
      .trees:nth-last-child(2):first-child ~ .trees {
        height: calc(50% - 6px);
      }
    }
    .equipment-right {
      flex: 1;
      margin-left: 16px;
      .e-r-top {
        height: 42px;
        padding: 0px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        color: var(--theme-color-customized-1);
        border-bottom: 2px solid #d7ecf3;
      }
      .e-r-center {
        height: calc(100% - 60px - 44px);
        box-sizing: border-box;
        overflow-y: scroll;
      }
      .e-r-bottom {
        height: 60px;
      }
    }
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: var(--theme-color-customized-1);
    }
    th:last-child > .cell {
      text-align: center;
    }
  }
  .filter {
    padding-left: 18px;
    .title {
      text-align: center;
      font-size: 16px;
      color: var(--theme-color-customized-1);
    }
    .check-all {
      padding-bottom: 6px;
    }
  }
  .filter + .filter {
    .title {
      padding-top: 10px;
    }
  }
}
</style>
